import { z } from "zod";
export const redditConnectionInput = z.object({
  name: z.string().trim().min(1),
});
export const redditTrackingConfig = z.object({
  subreddit: z
    .string()
    .trim()
    .regex(/^(?:r\/)?[A-Za-z0-9_]{2,21}$/),
  keywords: z.array(z.string().trim().min(1)),
  since: z.iso.datetime(),
});
export const redditSourceInput = redditTrackingConfig.extend({
  integrationId: z.string().min(1),
});
export const redditSourceUpdate = redditTrackingConfig
  .omit({ subreddit: true })
  .extend({ enabled: z.boolean() });
export const redditSourceSchema = redditSourceInput.extend({
  id: z.uuid(),
  resourceId: z.uuid(),
  name: z.string(),
  enabled: z.boolean(),
  lastSyncAt: z.string().nullable(),
});
export type RedditSource = z.infer<typeof redditSourceSchema>;
export const redditTaskKey = z.enum(["collect_reddit_posts", "collect_reddit_comments"]);
export const redditCollectInput = z.object({
  runId: z.uuid(),
  taskKey: redditTaskKey,
  attempt: z.number().int().positive(),
});
export const redditCollectResult = z.object({ done: z.boolean() });
